"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieLevel = exports.StateGuardEnum = exports.CookieConsentGroups = exports.CookieConsentSettingState = exports.ABTestCookieValue = exports.ABTestCookie = exports.Cookie = void 0;
var Cookie;
(function (Cookie) {
    Cookie["_UUID"] = "_UUID";
    Cookie["BROWSER_GEOLOCATION"] = "browserGeoLocation";
    Cookie["CLICK_AND_COLLECT_STORE"] = "clickandcollectstore";
    Cookie["CONSENT_SETTING"] = "consent_setting";
    Cookie["FREDHOPPER_SEGMENT"] = "fredhopperSegment";
    Cookie["LEVEL"] = "cookieLevel";
    Cookie["STATE_GUARD"] = "stateGuard";
    Cookie["IS_BASKET_REMINDER_CALLED"] = "isBasketReminderCalled";
})(Cookie || (exports.Cookie = Cookie = {}));
var ABTestCookie;
(function (ABTestCookie) {
    ABTestCookie["SIZE_BUTTONS"] = "sizebuttongroup";
    ABTestCookie["AI_SEARCH"] = "aisearch";
    ABTestCookie["PRODUCT_BUNDLES"] = "productbundles";
    ABTestCookie["BPOST_ADDRESS_VALIDATION"] = "addressvalidationgroup";
    ABTestCookie["BASKET_REMINDER_NOTIFICATION"] = "basketremindernotificationgroup";
    ABTestCookie["EMBEDDED_CONTENT"] = "embeddedcontentgroup";
    ABTestCookie["MOBILE_NAVIGATION"] = "mobilenavigationgroup";
    ABTestCookie["DISABLE_AMEX_PAYMENT"] = "amexgroup";
    ABTestCookie["HIDE_ADDITIONAL_PRODUCT_SELECTOR"] = "hideAdditionalProductSelector";
    ABTestCookie["HIDE_BUNDLE_DEAL"] = "hideBundleDeal";
    ABTestCookie["CHECKOUT_WITH_DETAILS"] = "loginflowswithdetailsgroup";
    ABTestCookie["CHECKOUT_WITHOUT_DETAILS"] = "loginflowswithoutdetailsgroup";
    ABTestCookie["NEW_MOBILE_FILTER_DESIGN"] = "abgroup_newmobilefilterdesign";
})(ABTestCookie || (exports.ABTestCookie = ABTestCookie = {}));
var ABTestCookieValue;
(function (ABTestCookieValue) {
    ABTestCookieValue["A"] = "A";
    ABTestCookieValue["B"] = "B";
})(ABTestCookieValue || (exports.ABTestCookieValue = ABTestCookieValue = {}));
var CookieConsentSettingState;
(function (CookieConsentSettingState) {
    CookieConsentSettingState[CookieConsentSettingState["OLD_COMPONENT"] = 0] = "OLD_COMPONENT";
    CookieConsentSettingState[CookieConsentSettingState["NO_CONSENTS_AVAILABLE"] = 1] = "NO_CONSENTS_AVAILABLE";
    CookieConsentSettingState[CookieConsentSettingState["CONSENTS_AVAILABLE"] = 2] = "CONSENTS_AVAILABLE";
})(CookieConsentSettingState || (exports.CookieConsentSettingState = CookieConsentSettingState = {}));
var CookieConsentGroups;
(function (CookieConsentGroups) {
    CookieConsentGroups["FUNCTIONAL"] = "functional";
    CookieConsentGroups["ANALYTICS"] = "analytics";
    CookieConsentGroups["MARKETING"] = "marketing";
})(CookieConsentGroups || (exports.CookieConsentGroups = CookieConsentGroups = {}));
var StateGuardEnum;
(function (StateGuardEnum) {
    StateGuardEnum["NEWSLETTER_SUBSCRIPTION"] = "newsletter_subscription";
    StateGuardEnum["AUTHENTICATED"] = "authenticated";
})(StateGuardEnum || (exports.StateGuardEnum = StateGuardEnum = {}));
var CookieLevel;
(function (CookieLevel) {
    CookieLevel[CookieLevel["LEVEL_ZERO"] = 0] = "LEVEL_ZERO";
    CookieLevel[CookieLevel["LEVEL_ONE"] = 1] = "LEVEL_ONE";
    CookieLevel[CookieLevel["LEVEL_TWO"] = 2] = "LEVEL_TWO";
})(CookieLevel || (exports.CookieLevel = CookieLevel = {}));
//# sourceMappingURL=CookieEnums.js.map